import React from 'react';
import { GammaMetricKey } from '../types/StockData';

interface GammaMetricSelectorProps {
  selectedMetric: GammaMetricKey;
  onMetricChange: (metric: GammaMetricKey) => void;
}

const GammaMetricSelector: React.FC<GammaMetricSelectorProps> = ({ selectedMetric, onMetricChange }) => {
  const metrics: { key: GammaMetricKey; label: string; description: string }[] = [
    {
      key: 'netGamma',
      label: 'Net Gamma',
      description: 'Total gamma exposure across all options'
    },
    {
      key: 'netCallGamma',
      label: 'Net Call Gamma',
      description: 'Gamma exposure from call options only'
    },
    {
      key: 'netPutGamma',
      label: 'Net Put Gamma',
      description: 'Gamma exposure from put options only'
    },
    {
      key: 'netDelta',
      label: 'Net Delta',
      description: 'Total delta exposure across all options'
    },
    {
      key: 'netVanna',
      label: 'Net Vanna',
      description: 'Sensitivity of delta to volatility changes'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg p-4 mb-4">
      <h3 className="text-lg font-semibold mb-3 text-gray-800">Select Gamma Metric</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-2">
        {metrics.map((metric) => (
          <button
            key={metric.key}
            onClick={() => onMetricChange(metric.key)}
            className={`p-3 rounded-lg border-2 transition-all duration-200 text-left ${
              selectedMetric === metric.key
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
            }`}
            title={metric.description}
          >
            <div className="font-medium text-sm">{metric.label}</div>
            <div className="text-xs text-gray-500 mt-1">{metric.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default GammaMetricSelector;
